'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SignupCard = exports.SignupCardUnwrapped = exports.TRANSITION_DELAY = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _toArray2 = require('babel-runtime/helpers/toArray');

var _toArray3 = _interopRequireDefault(_toArray2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _object = require('helpers/object');

var ObjectUtil = _interopRequireWildcard(_object);

var _Sagas = require('decorators/Sagas');

var _decorator = require('helpers/decorator');

var _verify = require('helpers/verify');

var _AccountCard = require('./AccountCard');

var _LeadCard = require('./LeadCard');

var _ProductCard = require('./ProductCard');

var _ProductForm = require('../forms/ProductForm');

var _signupCard = require('../sagas/signup-card.saga');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/sort-comp,react/jsx-handler-names */
var STEPS = {
  ACCOUNT: 'account',
  LEAD: 'lead',
  PRODUCT: 'product'
};

var TRANSITION_DELAY = exports.TRANSITION_DELAY = 600;

var SignupCardUnwrapped = exports.SignupCardUnwrapped = function (_Component) {
  (0, _inherits3.default)(SignupCardUnwrapped, _Component);

  function SignupCardUnwrapped() {
    var _ref;

    (0, _classCallCheck3.default)(this, SignupCardUnwrapped);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = SignupCardUnwrapped.__proto__ || (0, _getPrototypeOf2.default)(SignupCardUnwrapped)).call.apply(_ref, [this].concat(args)));

    _this.advanceStep = _this.advanceStep.bind(_this);
    _this.clearPreviousStep = _this.clearPreviousStep.bind(_this);
    _this.onComplete = _this.onComplete.bind(_this);
    _this.renderStepAccount = _this.renderStepAccount.bind(_this);
    _this.renderStepLead = _this.renderStepLead.bind(_this);
    _this.renderStepProduct = _this.renderStepProduct.bind(_this);

    _this.state = {
      steps: [STEPS.PRODUCT, STEPS.LEAD, STEPS.ACCOUNT],
      previousStep: null
    };
    return _this;
  }

  (0, _createClass3.default)(SignupCardUnwrapped, [{
    key: 'advanceStep',
    value: function advanceStep(results) {
      var _state = this.state,
          steps = _state.steps,
          stepResults = _state.stepResults;

      var _steps = (0, _toArray3.default)(steps),
          currentStep = _steps[0],
          nextSteps = _steps.slice(1);

      this.setState({ stepResults: (0, _extends3.default)({}, stepResults, results) });

      if ((0, _verify.isEmpty)(nextSteps)) {
        this.onComplete();
      } else {
        this.setState({
          steps: nextSteps,
          previousStep: currentStep
        });
      }
    }
  }, {
    key: 'clearPreviousStep',
    value: function clearPreviousStep() {
      this.setState({ previousStep: null });
    }
  }, {
    key: 'hasPreviousStep',
    value: function hasPreviousStep() {
      return Boolean(this.state.previousStep);
    }
  }, {
    key: 'isCurrentStep',
    value: function isCurrentStep(step) {
      return this.state.steps[0] === step;
    }
  }, {
    key: 'isPreviousStep',
    value: function isPreviousStep(step) {
      return this.state.previousStep === step;
    }
  }, {
    key: 'onComplete',
    value: function onComplete() {
      if (this.props.onComplete) {
        this.props.onComplete(this.props.url);
      }
    }
  }, {
    key: 'renderStep',
    value: function renderStep(stepName, stepRenderer) {
      if (this.isPreviousStep(stepName)) {
        setTimeout(this.clearPreviousStep, TRANSITION_DELAY);
        return _react2.default.createElement(
          'div',
          { className: 'anim anim--fadeOut' },
          stepRenderer()
        );
      } else if (this.isCurrentStep(stepName) && !this.hasPreviousStep()) {
        return _react2.default.createElement(
          'div',
          { className: 'anim anim--fadeIn' },
          stepRenderer()
        );
      }
    }
  }, {
    key: 'renderStepAccount',
    value: function renderStepAccount() {
      return _react2.default.createElement(_AccountCard.AccountCard, {
        hiddenFields: this.state.stepResults,
        onSuccess: this.advanceStep,
        tag: this.props.tag
      });
    }
  }, {
    key: 'renderStepLead',
    value: function renderStepLead() {
      return _react2.default.createElement(_LeadCard.LeadCard, {
        hiddenFields: (0, _extends3.default)({}, this.state.stepResults, { resumeSignupLink: this.props.url }),
        onLeadSuccess: this.advanceStep,
        onFacebookSuccess: this.onComplete,
        tag: this.props.tag
      });
    }
  }, {
    key: 'renderStepProduct',
    value: function renderStepProduct() {
      var _props = this.props,
          ctaCopy = _props.ctaCopy,
          productId = _props.productId,
          productType = _props.productType;

      var productCardProps = ObjectUtil.pick((0, _keys2.default)(_ProductCard.ProductCard.propTypes), this.props);
      var cta = _react2.default.createElement(_ProductForm.ProductForm, {
        copy: ctaCopy,
        hiddenFields: (0, _extends3.default)({}, this.state.stepResults, {
          productId: productId,
          productType: productType,
          resumeSignupLink: this.props.url
        }),
        onSuccess: this.advanceStep
      });

      return _react2.default.createElement(_ProductCard.ProductCard, (0, _extends3.default)({}, productCardProps, { cta: cta }));
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _react.Fragment,
        null,
        this.renderStep(STEPS.ACCOUNT, this.renderStepAccount),
        this.renderStep(STEPS.LEAD, this.renderStepLead),
        this.renderStep(STEPS.PRODUCT, this.renderStepProduct)
      );
    }
  }]);
  return SignupCardUnwrapped;
}(_react.Component);

SignupCardUnwrapped.propTypes = (0, _extends3.default)({}, _ProductCard.ProductCard.propTypes, {
  productId: _propTypes2.default.number,
  productType: _propTypes2.default.string
});

var SignupCard = exports.SignupCard = (0, _decorator.decorateWith)((0, _Sagas.withSagas)({ watch: _signupCard.watchSignupCardSagas }), (0, _reactRedux.connect)(null, { onComplete: _signupCard.redirectToNextStep }), (0, _decorator.withName)('SignupCard'))(SignupCardUnwrapped);